module.exports = __webpack_public_path__ + "img/logo-small-red-05.1896b3dd.png";